import App from './app';
import { StrictMode } from 'react';
import { APP_ROOT_ID } from './shared/constants';
import { createRoot } from 'react-dom/client';

createRoot(document.getElementById(APP_ROOT_ID)!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
